module.exports = __webpack_public_path__ + "static/media/Piercing-mascintimate-guiche.874b12f3.png";